// <!-- GRACE:MODULE_START name="ui_auth" -->
// <!-- GRACE:DEPENDENCY target="ui_auth" -->
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface ChangePasswordForm {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}

// <!-- GRACE:CONTRACT function="ChangePasswordPage" -->
export default function ChangePasswordPage() {
  const { changePassword } = useAuth();
  const navigate = useNavigate();
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { register, handleSubmit, watch, formState: { errors } } = useForm<ChangePasswordForm>();
  const newPassword = watch('newPassword');

  const onSubmit = async (data: ChangePasswordForm) => {
    setError('');
    setMessage('');
    setLoading(true);
    try {
      const msg = await changePassword(data.currentPassword, data.newPassword);
      setMessage(msg);
    } catch (e: any) {
      setError(e.message || 'Ошибка смены пароля');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-md rounded-2xl border bg-white p-8 shadow-sm">
        <div className="mb-6">
          <button
            onClick={() => navigate('/app')}
            className="mb-4 text-sm text-gray-500 hover:text-gray-900"
          >
            &larr; Назад
          </button>
          <h1 className="text-xl font-semibold">Смена пароля</h1>
        </div>

        {message && (
          <div className="mb-4 rounded-lg bg-green-50 p-3 text-sm text-green-700">{message}</div>
        )}
        {error && (
          <div className="mb-4 rounded-lg bg-red-50 p-3 text-sm text-red-600">{error}</div>
        )}

        <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
          <div>
            <label className="mb-1 block text-sm font-medium">Текущий пароль</label>
            <input
              type="password"
              className="w-full rounded-lg border px-3 py-2 text-sm focus:border-gray-400 focus:outline-none"
              {...register('currentPassword', { required: 'Введите текущий пароль' })}
            />
            {errors.currentPassword && (
              <p className="mt-1 text-xs text-red-500">{errors.currentPassword.message}</p>
            )}
          </div>

          <div>
            <label className="mb-1 block text-sm font-medium">Новый пароль</label>
            <input
              type="password"
              className="w-full rounded-lg border px-3 py-2 text-sm focus:border-gray-400 focus:outline-none"
              placeholder="Минимум 8 символов"
              {...register('newPassword', {
                required: 'Введите новый пароль',
                minLength: { value: 8, message: 'Минимум 8 символов' },
              })}
            />
            {errors.newPassword && (
              <p className="mt-1 text-xs text-red-500">{errors.newPassword.message}</p>
            )}
          </div>

          <div>
            <label className="mb-1 block text-sm font-medium">Подтверждение нового пароля</label>
            <input
              type="password"
              className="w-full rounded-lg border px-3 py-2 text-sm focus:border-gray-400 focus:outline-none"
              placeholder="Повторите новый пароль"
              {...register('confirmPassword', {
                required: 'Подтвердите новый пароль',
                validate: (v) => v === newPassword || 'Пароли не совпадают',
              })}
            />
            {errors.confirmPassword && (
              <p className="mt-1 text-xs text-red-500">{errors.confirmPassword.message}</p>
            )}
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full rounded-lg bg-gray-900 py-2.5 text-sm font-medium text-white hover:bg-gray-800 disabled:opacity-50"
          >
            {loading ? 'Сохранение...' : 'Изменить пароль'}
          </button>
        </form>
      </div>
    </div>
  );
}
// <!-- GRACE:MODULE_END name="ui_auth" -->
